import { render, staticRenderFns } from "./PSelect.vue?vue&type=template&id=03117ab8&scoped=true&"
import script from "./PSelect.vue?vue&type=script&lang=js&"
export * from "./PSelect.vue?vue&type=script&lang=js&"
import style0 from "./PSelect.vue?vue&type=style&index=0&id=03117ab8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03117ab8",
  null
  
)

export default component.exports